// Basic / free Site cards that every player has access to from day one.
// These are the same four basic realms offered in the Draft UI as
// unlimited free sites for atlas-building. Players don't need to unlock
// them through a Realm Pack. They're always available as profile
// background choices alongside any sites the player has purchased.
//
// Keep this list in sync with `BASIC_SITE_IDS` in the server repo's
// `src/data/basicSites.js`. The server validates background picks
// against the same set, so adding a new basic site requires changes
// in both repos.
export const BASIC_SITE_IDS = [
  'sorcery-spire',     // Air
  'sorcery-stream',    // Water
  'sorcery-valley',    // Earth
  'sorcery-wasteland', // Fire
];

export function isBasicSite(cardId) {
  return BASIC_SITE_IDS.includes(cardId);
}
